import { connect } from 'react-redux'
import Closest     from '../components/Closest';


const mapStateToProps = (state) => {
    return {
        displayClosest: state.geo.watching,
        closest       : state.closest,
        theme         : state.assets.items.theme
    }
};

Closest.defaultProps = {
    version: 'large'
};

const ClosestContainer = connect(mapStateToProps)(Closest);

export default ClosestContainer;


// WEBPACK FOOTER //
// ./src/containers/ClosestContainer.js